module.exports = window.EhsReact; 